import React from "react";
import * as s from "./index.module.scss";
import { PrismicRichText } from "@prismicio/react";

const Richtext = ({ data }) => {
  return (
    <section className={s.richtext_content}>
      <div className={s.body_container}>
          <PrismicRichText field={data} />
      </div>
    </section>
  );
};

export default Richtext;
